// This file was auto-generated by Fern from our API Definition.
export var TopUpPacksResponse;
(function (TopUpPacksResponse) {
    TopUpPacksResponse.Status = {
        Available: "available",
        PaidPlanRequired: "paid_plan_required",
        Unavailable: "unavailable",
    };
})(TopUpPacksResponse || (TopUpPacksResponse = {}));
